import { loadTemplate } from "utils/load_template"
import { CustomControlBase } from "wistia/player_controls/custom_control_base"

export class CustomPlayControl extends CustomControlBase {
  constructor(video, options) {
    super(video, options)
    this.onClickButton = this.onClickButton.bind(this)
    this.updateButton = this.updateButton.bind(this)
  }

  mountButton(buttonRoot) {
    this.buttonRoot = buttonRoot
    this.updateButton()
    this.video.bind("pause", this.updateButton)
    this.video.bind("play", this.updateButton)
    this.video.bind("end", this.updateButton)
  }

  onClickButton(event) {
    if (this.video.state() === "playing") {
      this.video.pause()
    } else {
      this.video.play()
    }
  }

  updateButton() {
    if (this.video.state() === "playing") {
      this.buttonRoot.innerHTML = loadTemplate("video-player-pause-control-template")
      this.setButtonLabel("Pause")
    } else {
      this.buttonRoot.innerHTML = loadTemplate("video-player-play-control-template")
      this.setButtonLabel("Play")
    }
  }
}
CustomPlayControl.sortValue = 1
CustomPlayControl.handle = 'customPlayControl'
